import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import { mapGetters, mapActions } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtBreadcrumb from '@/common/components/mvtbreadcrumb/mvt-breadcrumb.vue';
import featuredArticle from '@/common/components/featured-article/featured-article.presentational.vue';
import tabGroup from '@/common/components/tabgroup/tabgroup.presentational.vue';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import mvtNewMap from '@/common/components/mvtnewmap/mvt-newmap.vue';
// import mvtNewFooter from '@/common/components/mvtnewfooter/mvtnewfooter.vue';
import guidePaginate from '@/guide/components/guidepaginate/guide-paginate.vue';
import guideArticle from '@/guide/components/guidearticle/guide-article.vue';
import guideHub from '@/guide/components/guidehub/guide-hub.vue';
import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';

export default {
    name: 'pageGuide',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        mvtHeader,
        mvtDialogCenter,
        mvtFooter,
        mvtBreadcrumb,
        featuredArticle,
        tabGroup,
        mvtNearby,
        // mvtNewFooter,
        guidePaginate,
        guideArticle,
        guideHub,
        mvtDropdownList,
        mvtNewMap,
    },
    data() {
        return {
            tabs: ['latest', 'popular'],
        };
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
        ...mapGetters('guide', ['guide', 'relatedArticleCards', 'relatedArticleLinks']),
        getCategories() {
            return this.guide.categories;
        },
        pageType() {
            return this.guide.pageType || 'vguide';
        },
        breadcrumbGeo() {
            const defaultCrumbs = {
                homeText: 'Home',
                state: 'Guides',
                statePath: 'guide/',
            };
            const currentCategory = this.guide?.categories?.filter((category) => category.text.toLowerCase() === this.guide.pageHeading.toLowerCase())?.[0];
            return currentCategory
                ? {
                      ...defaultCrumbs,
                      county: currentCategory.text,
                      countyPath: currentCategory.path,
                  }
                : defaultCrumbs;
        },
        articles() {
            return {
                highlights: this.guide.latestArticles.slice(0, 2),
                latest: this.guide.latestArticles.slice(2),
                popular: this.guide.hottestArticles,
            };
        },
    },
    methods: {
        ...mapActions('glb', ['getBoundaries']),
        ...mapActions('guide', ['fetchGuideCategories']),
        initializeMap() {
            this.$refs.map && this.$refs.map.moveMap(this.guide.geo.lat, this.guide.geo.lng);
        },
    },
    mounted() {
        this.$eventBus.$emit('eventbus-pageLoaded');
        this.fetchGuideCategories();
    },
};
